import { ICommonIconProps } from '@/types/shared'
import React, { FC } from 'react'

export const CheckRoundedIcon: FC<ICommonIconProps> = ({
  width = '24',
  height = '24',
  className = 'text-v8-violet',
  fill = 'none',
  stroke = 'currentColor',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      strokeWidth="1.5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      ></path>
    </svg>
  )
}
